export default {
  US: {
    fields: {
      firstName: { required: true },
      lastName: { required: true },
      addressOne: { required: true },
      addressTwo: { required: false },
      city: { required: true, label: 'City' },
      state_province: { required: true, label: 'State', disabled: false },
      countryCode: { required: true },
      postalCode: {
        required: true,
        pattern_error_msg: 'Only numbers, spaces, and dashes are allowed',
        pattern: /[0-9\-\s]+/,
      },
    },
    mobileOptions: {},
  },
  MILITARY: {
    fields: {
      firstName: { required: true },
      lastName: { required: true },
      addressOne: { required: true },
      addressTwo: { required: false },
      city: { required: false, label: 'Postal Service' },
      state_province: { required: true, label: 'State', disabled: false },
      countryCode: { required: true },
      postalCode: {
        required: true,
        pattern_error_msg: 'Only numbers, spaces, and dashes are allowed',
        pattern: /[0-9\-\s]+/,
      },
    },
    mobileOptions: {},
  },
  CANADA: {
    fields: {
      firstName: { required: true },
      lastName: { required: true },
      addressOne: { required: true },
      addressTwo: { required: false },
      city: { required: true, label: 'City' },
      state_province: { required: true, label: 'Province', disabled: false },
      countryCode: { required: true },
      postalCode: {
        required: true,
        pattern_error_msg: 'Only letters, numbers, and spaces are allowed',
        pattern: /[a-zA-Z0-9\s]+/,
      },
    },
    mobileOptions: {},
  },
  INTERNATIONAL: {
    fields: {
      firstName: { required: true },
      lastName: { required: true },
      addressOne: { required: true },
      addressTwo: { required: false },
      city: { required: true, label: 'City' },
      state_province: { required: false, visible: false, disabled: true },
      countryCode: { required: true },
      postalCode: {
        required: false,
        pattern_error_msg: 'Only numbers, capital letters, spaces, and dashes are allowed',
        pattern: /[0-9A-Z\-\s]+/,
      },
    },
    mobileOptions: {},
  },
}
